// Formulář chatu Moodix AI (moodix/templates/app/ai/_panel_body.html): otázka se v konverzaci ukáže hned
// a pod ní bublina „Moodix AI pracuje“ s fázemi a časem. Server vrací otázku i odpověď najednou (_exchange.html),
// takže se po vložení odpovědi dočasná otázka i bublina odstraní; odmítnutí bez otázky (_limit.html) otázku ponechá.
// Úklid je v htmx:after-request (vzniká na formuláři; before-swap vzniká na #ai-msgs mimo formulář).
// Texty fází a chyby přicházejí přeložené z šablony (data-s0…s3, data-error); fáze se přepínají podle STAGE_AT.

const STAGE_AT = [0, 4, 9, 20];  // sekundy: čtení dat → kontrola sentimentu → psaní odpovědi → „trvá to déle“

export function aiAsk() {
  return {
    busy: false,
    question: '',
    started: 0,
    timer: null,

    box() {
      return document.getElementById('ai-msgs');
    },

    stages() {
      return STAGE_AT.map((at, i) => [at, this.$root.dataset[`s${i}`] || '']);
    },

    before() {
      const q = this.$refs.q;
      this.question = q.value.trim();
      this.busy = true;
      q.disabled = true;
      const box = this.box();
      if (!box) return;
      box.querySelectorAll('.aid-temp, .aid-pending').forEach((n) => n.remove());
      if (this.question) {
        const u = document.createElement('div');
        u.className = 'um aid-temp';
        u.textContent = this.question;
        box.appendChild(u);
      }
      const tpl = document.getElementById('ai-pending-tpl');
      const pending = tpl.content.firstElementChild.cloneNode(true);
      box.appendChild(pending);
      box.scrollTop = box.scrollHeight;
      this.started = Date.now();
      this.tick(pending);
      this.timer = setInterval(() => this.tick(pending), 1000);
    },

    tick(pending) {
      const secs = (Date.now() - this.started) / 1000;
      const list = this.stages();
      let text = list.length ? list[0][1] : '';
      for (const [at, t] of list) if (secs >= at) text = t;
      const label = pending.querySelector('.aip-text');
      if (label && label.textContent !== text) label.textContent = text;
      const clock = pending.querySelector('.aip-secs');
      if (clock) clock.textContent = secs >= 8 ? `${Math.floor(secs)} s` : '';
    },

    after(event) {
      this.stop();
      this.busy = false;
      const q = this.$refs.q;
      q.disabled = false;
      const box = this.box();
      box?.querySelectorAll('.aid-pending').forEach((n) => n.remove());
      if (event.detail.successful) {
        // Odpověď s otázkou (_exchange.html) nahrazuje dočasnou otázku; odmítnutí bez ní (_limit.html) ji ponechá
        const html = event.detail.xhr?.responseText || '';
        box?.querySelectorAll('.um.aid-temp').forEach((n) => (html.includes('class="um"') ? n.remove() : n.classList.remove('aid-temp')));
        q.value = '';
      } else {
        // Chyba nebo výpadek spojení: otázka zpět do pole, v konverzaci krátké vysvětlení
        q.value = this.question;
        if (box) {
          box.querySelectorAll('.um.aid-temp').forEach((n) => n.remove());
          const err = document.createElement('div');
          err.className = 'am refuse aid-temp';
          err.textContent = this.$root.dataset.error || '';
          box.appendChild(err);
          box.scrollTop = box.scrollHeight;
        }
      }
      q.focus();
    },

    ask(text) {
      // Návrh otázky (čip) – jen když se zrovna na nic nečeká
      if (this.busy) return;
      this.$refs.q.value = text;
      this.$refs.form.requestSubmit();
    },

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    },
  };
}
